<template>
   <div class="structure">
      <!-- {{ data.name }} -->
      <Container
         v-for="container in sortedContainer"
         :key="container.title+'-'+container.order"
         :data="container"
         :depth="1"
         :location="location+'>'+container.title+'-'+container.order"
         @creditUpdate="updateCredits"
      />
   </div>
</template>

<script>
   import { mapState, mapActions } from 'vuex'
   import {dynamicSort} from 'common/models/sorting.js'

   import Container from './container.vue'
   export default {
      name: "Structure",
      data: function(){
         return {
            credits: 0,
         }
      },
      components: {
         Container
      },
      props: {
         data: {
            type: Object,
            required: true
         },
         type: {
            type: String,
            required: false
         },
         location: {
            type: String,
            required: false,
         },
      },
      computed: {
         ...mapState({
            locked: state => state.selections.locked,
         }),
         sortedContainer: function(){
            return this.data.containers.sort( dynamicSort("order") );
         },

      },
      methods: {
         updateCredits(c){
            this.credits = this.credits + c;
         },
      },
      watch: {
         credits: function(newVal, oldVal){
            this.$emit('creditUpdate', newVal-oldVal);
         }
      }
   }
</script>

